export function toTitleCase(str: string): string {
    return str.replace(/\b[a-z]/g, (m) => {
        return m[0].toUpperCase();
    });
}